import { Link } from "react-router-dom";
import { FadeIn } from "@/components/Reveal";
import { ROOM_TYPES } from "@/lib/site";
import { useCategoryPhotos, pickPhoto } from "@/lib/usePhotos";
import UploadedPhotos from "@/components/UploadedPhotos";
import { ArrowUpRight } from "lucide-react";

export default function Accommodation() {
  const roomPhotos = useCategoryPhotos("room");
  const images = ROOM_TYPES.map((_, i) => pickPhoto(roomPhotos, i));
  return (
    <main data-testid="accommodation-page" className="pt-32 pb-24">
      <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeIn>
          <div className="stamp mb-8">Vol · II · Stay</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#F2E7D0] max-w-5xl">
            Nilika Lall <em className="italic text-[#D97645]">Residency</em>.
          </h1>
          <p className="mt-8 max-w-xl text-[#B8A891] text-lg">
            Peace, tranquillity, solitude & spiritual vibes.
          </p>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {ROOM_TYPES.map((r, i) => (
          <FadeIn delay={i * 0.1} key={r.id}>
            <div data-testid={`room-card-${r.id}`} className="group">
              <div className="overflow-hidden aspect-[4/5] bg-[#27221C]">
                {images[i] && <img src={images[i]} alt={r.name} className="w-full h-full object-cover vintage-img group-hover:scale-[1.03] transition-transform duration-700" />}
              </div>
              <div className="mt-6 flex items-baseline justify-between">
                <div className="chapter-num">{r.name}</div>
                <div className="font-mono-label text-[#F2E7D0]">{r.price} / night</div>
              </div>
              <h3 className="mt-3 font-display text-4xl text-[#F2E7D0]">{r.name}</h3>
              <div className="mt-2 flex items-center gap-3 text-xs font-mono-label text-[#B8A891]">
                <span>Sleeps {r.sleeps}</span>
                <span>·</span>
                <span>{r.inventory} rooms</span>
              </div>
              <p className="mt-3 text-sm text-[#B8A891] leading-relaxed">{r.desc}</p>
              <Link
                to="/booking"
                state={{ room: r.id }}
                data-testid={`book-${r.id}-btn`}
                className="mt-6 inline-flex items-center gap-2 link-underline font-mono-label text-[#D97645]"
              >
                Reserve this room <ArrowUpRight size={14} />
              </Link>
            </div>
          </FadeIn>
        ))}
      </section>

      <UploadedPhotos category="room" kicker="More Rooms" title="Inside the estate — recent stays." />
    </main>
  );
}
